import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { LabelSelectorModule } from '@core/components/label-selector/label-selector.module';
import { ShowDataInputModule } from '@core/components/show-data-input/show-data-input.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogQuotationComponent } from './dialog-quotation.component';
import { DialogUpdatedModule } from './dialog-updated/dialog-updated.module';
import { TabQuotationAttachmentsComponent } from './tabs/attachments/tab-quotation-attachments.component';
import { TabGeneralComponent } from './tabs/general/tab-general.component';

@NgModule({
  entryComponents: [
    DialogQuotationComponent,
  ],
  declarations: [
    DialogQuotationComponent,
    TabGeneralComponent,
    TabQuotationAttachmentsComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,

    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatTooltipModule,
    MatCheckboxModule,
    ShowDataInputModule,
    LabelSelectorModule,
    DialogUpdatedModule,
    DisclaimerModule,
  ],
  exports: [
    DialogQuotationComponent
  ]
})
export class DialogQuotationModule { }
